import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Ncm } from "@interfaces/ncm";
import { descricaoNcm } from "src/app/utils/ncm-descricao.util";
import {
  joinFaltantes,
  ncmCamposFaltantes
} from "src/app/utils/parametrizacao.util";

@Component({
  selector: "app-ncm-card",
  templateUrl: "./ncm-card.component.html",
  styleUrls: ["./ncm-card.component.scss"]
})
export class NcmCardComponent {
  @Output() edit = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();
  @Input() ncm?: Ncm;

  /** Rascunho importado pelo CNAE: o que ainda falta para emitir. */
  get faltantes() {
    return ncmCamposFaltantes(this.ncm);
  }

  get parametrizado() {
    return this.faltantes.length === 0;
  }

  get faltantesTexto() {
    return joinFaltantes(this.faltantes);
  }

  /** Descrição oficial do NCM (tabela do app), sem o código na frente. */
  get descricao() {
    return descricaoNcm(this.ncm?.ncm);
  }

  get ibscbsTexto() {
    const cst = this.ncm?.tributos?.ibscbs?.cst;
    const classificacao = this.ncm?.tributos?.ibscbs?.classificacao;
    if (!cst && !classificacao) return "—";
    return [cst && `CST ${cst}`, classificacao && `cClassTrib ${classificacao}`]
      .filter(Boolean)
      .join(" · ");
  }
}
